/** Panel / site kullanici rolleri (crole). */
export const CROLE_DEFINITIONS = [
  { id: 'operator', name: 'Operator' },
  { id: 'editor', name: 'Editor' },
  { id: 'promoter', name: 'Promoter' },
  { id: 'venueManager', name: 'Venue Manager' },
  { id: 'organisationCompanyManager', name: 'Organisation Company Manager' },
  { id: 'admin', name: 'Admin' },
];

/** Users edit — admin tum rolleri atayabilsin */
export const CROLES_ASSIGNABLE = CROLE_DEFINITIONS;

/** Panel girisinde kabul edilen roller (+ affiliate) */
export const PANEL_LOGIN_ROLE_IDS = [...CROLE_DEFINITIONS.map((r) => r.id), 'affiliate'];

/**
 * Eski export: bazi formlarda sadece operator/editor acik kalsin diye disabled.
 * Users edit artik CROLES_ASSIGNABLE kullanir.
 */
const CROLES = CROLE_DEFINITIONS.map((r) => ({
  ...r,
  disabled: !['operator', 'editor'].includes(r.id),
}));

export default CROLES;
